module.exports = __webpack_public_path__ + "media/customizations/bedfordlife/back-46c474f458858b4c279b03811364d6ba.jpg";